import { getGenderPathPrefix } from '../../utils/getGenderPathPrefix'
import { NormalizedConditions } from '../types'

export const buildPath = (conditions: NormalizedConditions) => {
  let path = `/${getGenderPathPrefix(conditions.gender)}`
  const [snapItem] = conditions.snapItems
  if (
    snapItem === undefined ||
    conditions.snapItems.length > 1 ||
    (snapItem.brand === undefined && snapItem.category === undefined)
  ) {
    return `${path}coordinate/`
  }

  const { brand, category } = snapItem
  if (brand !== undefined) {
    path += `brand/${brand.key}/`
  } else {
    path += 'category/'
  }
  if (category) {
    path += `${category.key}/`
    if (category.child?.key) {
      path += `${category.child.key}/`
    }
  }
  return path
}
